module.exports = __webpack_public_path__ + "media/images/flags/gb-nir-7b28c4d150bdece38bf2fde2750abf36.svg";